import { FileDown } from "lucide-react";
import { exportBrochurePdf } from "../utils/exportPdf";

// Always-visible floating button that exports the full page as a PDF brochure.
// Hidden during printing via the .pdf-fab @media print rule in index.css.
export default function BrochureFab() {
  return (
    <button
      type="button"
      onClick={exportBrochurePdf}
      data-testid="brochure-fab"
      className="pdf-fab"
      aria-label="Export this page as a PDF brochure"
    >
      <FileDown size={16} strokeWidth={2.2} />
      <span>Export PDF</span>
    </button>
  );
}
